

















import Vue from 'vue'
import dict from '@custom/dict'
import utils from '@corets/utils'
import {CommonInput} from '@corets/formtype'
import {mapGetters} from 'vuex'
import NSmartInput from '@corecp/NSmartInput.vue'

interface FormModel {
    account: CommonInput,
    password: CommonInput,
    rules: any
}

interface CheckRules {
    [key: string]: any[]
}

interface LoginByAccountData {
    formModel: FormModel
}

export default Vue.extend({
    name: 'LoginByAccount',
    data () {
        const data: LoginByAccountData = {
            formModel: {
                account: {
                    placeholder: dict.localeObj.loginForm.accountPlaceholder,
                    value: '',
                    prefixIconType: 'user'
                },
                password: {
                    placeholder: dict.localeObj.loginForm.passwordPlaceholder,
                    value: '',
                    inputType: 'password',
                    prefixIconType: 'lock'
                },
                rules: {}
            }
        }
        return data
    },

    components: {
        NSmartInput
    },
    computed: {
        ...mapGetters([
            'locale'
        ])
    },
    watch: {
        locale () {
            // change locale to initRules for i18n show
            const self = this as any
            self.$refs.formModel.clearValidate()
            self.initRules()
        }
    },
    created () {
        const self = this as any
        self.initRules()
    },
    methods: {
        initRules () {
            const self = this as any
            self.formModel.rules = {
                ['account.value']: [
                    {
                        required: true,
                        message: self.$t(dict.localeObj.loginForm.accountEmptyErr),
                        trigger: 'blur'
                    }
                ],
                ['password.value']: [
                    {
                        required: true,
                        message: self.$t(dict.localeObj.loginForm.passwordEmptyErr),
                        trigger: 'blur'
                    }
                ]
            }
        },
        toLogin () {
            const self = this as any
            self.$emit('login')
        },
        fUserCode: utils.fUserCode
    }
})
